/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

import * as lc from '../../../../../utils/lodashCustom';

export function restructureContestModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    title: lc.get(data, 'title'),
    dateFrom: lc.get(data, 'date_from'),
    dateTo: lc.get(data, 'date_to'),
    descStatus: lc.get(data, 'desc_status'),
    descType: lc.get(data, 'desc_type'),
    lead: lc.get(data, 'lead'),
    descHtml: lc.get(data, 'desc_html'),
    descPrizesHtml: lc.get(data, 'desc_prizes_html'),
    prevImageUrl: lc.get(data, 'prev_image_url'),
    imageUrl: lc.get(data, 'image_url')
  };
}

export function restructureContestViewModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    title: lc.get(data, 'title'),
    dateFrom: lc.get(data, 'date_from'),
    dateTo: lc.get(data, 'date_to'),
    descStatus: lc.get(data, 'desc_status'),
    type: lc.get(data, 'type'),
    descType: lc.get(data, 'desc_type'),
    lead: lc.get(data, 'lead'),
    descHtml: lc.get(data, 'desc_html'),
    descPrizesHtml: lc.get(data, 'desc_prizes_html'),
    prevImageUrl: lc.get(data, 'prev_image_url'),
    imageUrl: lc.get(data, 'image_url'),
    contestsPlaces: _.map(lc.get(data, 'hideContestsPlaces'), item => ({
      place: lc.get(item, 'place'),
      contestPrize: {
        title: lc.get(item, 'contest_prize.title'),
        desc: lc.get(item, 'contest_prize.desc'),
        photoUrl: lc.get(item, 'contest_prize.photo_url')
      },
      contestUser: _.get(item, 'hideContestUser')
        ? {
            username: lc.get(item, 'hideContestUser.hideUser.username'),
            avatarPath: lc.get(
              item,
              'hideContestUser.hideUser.hideProfile.avatar_path'
            ),
            calculatedDesc: lc.get(item, 'hideContestUser.calculated_desc')
          }
        : null
    })),
    contestMeState: _.get(data, 'contest_me_state')
      ? {
          place: lc.get(data, 'contest_me_state.place'),
          contestUser: _.get(data, 'contest_me_state.hideUser')
            ? {
                username: lc.get(data, 'contest_me_state.hideUser.username'),
                avatarPath: lc.get(
                  data,
                  'contest_me_state.hideUser.hideProfile.avatar_path'
                ),
                calculatedDesc: lc.get(data, 'contest_me_state.calculated_desc')
              }
            : null
        }
      : null
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/contests/services/ContestsService/restructuring/index.js